import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useState } from 'react';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { Alert, Box, Divider } from '@mui/material';
import ReactDadataBox from 'react-dadata-box';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { Operator } from 'console/sim/types';
import { PhoneNumberField } from 'console/shared/components/fields/phone-number';
import { ControlWithoutValidation } from 'console/shared/components/fields/control/without-validation';
import { TextInputWrapper } from 'console/shared/components/fields/text';
import { useAppSelector } from 'shared/hooks/redux/hooks';
const initial_state = {
    operator: Operator.mts,
    fio: '',
    phone: '',
    postindex: '',
    address: '',
    error_shown: false,
    error_text: '',
};
export const SimOrderForm = memo(function SimOrderForm(props) {
    const { boxProps, header, payButton } = props;
    const [state, setState] = useState(initial_state);
    const email = useAppSelector((state) => state.account.email);
    const onPreCheck = useCallback(() => {
        if (!state.postindex || !state.address || !state.fio) {
            setState({
                ...state,
                error_shown: true,
                error_text: 'Заполните все поля, они необходимы для доставки',
            });
            return false;
        }
        return true;
    }, [state, setState]);
    const onChangeState = useCallback((key) => (value) => setState((state) => ({ ...state, [key]: value })), [setState]);
    const onAcceptSuggestion = useCallback((suggestion) => {
        setState((state) => ({
            ...state,
            postindex: suggestion.data.postal_code ?? '',
            address: suggestion.unrestricted_value ?? '',
        }));
    }, [setState]);
    const onCloseError = useCallback(() => setState((state) => ({ ...state, error_shown: false })), [setState]);
    return (_jsxs(ErrorBoundary, { children: [_jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, ...boxProps, children: [header, _jsx(Alert, { severity: "info", children: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u043C \u0412\u0430\u043C \u0441\u0438\u043C-\u043A\u0430\u0440\u0442\u0443 \u0437\u0430\u043A\u0430\u0437\u043D\u044B\u043C \u043F\u0438\u0441\u044C\u043C\u043E\u043C \u041F\u043E\u0447\u0442\u044B \u0420\u043E\u0441\u0441\u0438\u0438." }), _jsx(ControlWithoutValidation, { label: "\u0424\u0418\u041E \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F", value: state.fio, onChange: onChangeState('fio'), field: TextInputWrapper }), _jsx(ControlWithoutValidation, { label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D \u0434\u043B\u044F \u0441\u0432\u044F\u0437\u0438", value: state.phone, onChange: onChangeState('phone'), field: PhoneNumberField }), _jsx(Divider, {}), _jsxs(Box, { sx: {
                            '& label': {
                                display: 'block',
                                color: 'text.secondary',
                            },
                            '& react-dadata__input': {
                                color: 'text.secondary',
                                display: 'unset',
                            },
                        }, children: [_jsx("label", { className: "MuiFormLabel-root", htmlFor: "search", children: "\u041F\u043E\u0438\u0441\u043A \u0430\u0434\u0440\u0435\u0441\u0430" }), _jsx("div", { children: _jsx(ReactDadataBox, { token: "57e7f566181ccfabac9c0e725b1d687eb63f0161", count: 5, onChange: onAcceptSuggestion }) })] }), _jsx(ControlWithoutValidation, { label: "\u041F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u0438\u043D\u0434\u0435\u043A\u0441", value: state.postindex, onChange: onChangeState('postindex'), field: TextInputWrapper }), _jsx(ControlWithoutValidation, { label: "\u0410\u0434\u0440\u0435\u0441 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438", value: state.address, onChange: onChangeState('address'), field: TextInputWrapper }), _jsxs(Alert, { severity: "warning", children: ["\u041F\u043E\u0441\u043B\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0438 \u0442\u0440\u0435\u043A \u043D\u043E\u043C\u0435\u0440 \u043F\u0440\u0438\u0434\u0451\u0442 \u043D\u0430 \u043F\u043E\u0447\u0442\u0443 ", email] }), payButton({
                        operator: state.operator,
                        fio: state.fio,
                        phone: state.phone,
                        postindex: state.postindex,
                        address: state.address,
                    }, onPreCheck)] }), _jsx(ErrorBoundary, { children: _jsx(MessageBox, { isError: true, open: state.error_shown, onClose: onCloseError, title: "\u041D\u0435 \u0432\u0441\u0435 \u043F\u043E\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u044B", maxWidth: "xs", children: _jsx(Alert, { severity: "warning", children: state.error_text }) }) })] }));
});
